export default __webpack_public_path__ + "static/media/n4.b6292098.svg";